export default {
  moedas: [],
  moeda: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
